import { Message } from 'element-ui';
import serviceApi from '../../api/serviceAPI';
import router from '../../router';
import { getMenu, getRouters, getCache } from '../../utils/index';

const _ = require('lodash');

export default {
  state: {
    platform: '', // 用户所在平台 WX：微信 IPH：苹果 ADR：安卓  PC：电脑
    menuList: [], // 树形菜单
    permissions: [], // 全部权限按钮
    routes: [], // 可访问页面路由
    limits: [], // 全部权限按钮对象数组
    pathLimits: [], // 可跳转路由按钮
    cacheList: [], // 开启页面缓存
    isCollapse: false, // 展开收起，默认展开
  },
  getters: {
    // 用户平台所在平台
    platform: state => state.platform,
    menuList: state => state.menuList,
    permissions: state => state.permissions,
    routes: state => state.routes,
    isCollapse: state => state.isCollapse,
    limits: state => state.limits,
    pathLimits: state => state.pathLimits,
    cacheList: state => state.cacheList,
  },
  mutations: {
    openMenu(state) {
      state.isCollapse = !state.isCollapse;
    },
    clearArr(state) {
      state.routes = [];
    },
    getMenuArr(state, { menu }) {
      state.routes.push(menu);
    },
    getCacheArr(state, { menu }) {
      state.cacheList.push(menu);
    },
    setMenuAndButton(state, { menuList, permissions }) {
      state.menuList = menuList;
      state.permissions = [];
      state.limits = permissions;
      permissions.forEach((item) => {
        state.permissions.push(item.limit);
      });
      state.pathLimits = [];
      permissions.forEach((item) => {
        if (item.isLink === 'Y') {
          state.pathLimits.push(item);
        }
      });
      state.routes = [];
      getMenu(state.menuList);
      state.pathLimits.forEach((item) => {
        if (item.path) {
          state.routes.push(item.path);
        }
      });
      state.cacheList = [];
      getCache(state.menuList);
      // if (type && type === 'login') {
      //   // 跳转路由
      //   const route = menuList.find(item => item.path === '/home');
      //   if (route) {
      //     router.push({ path: route.path });
      //   } else {
      //     router.push({ path: menuList[0].children[0].path });
      //   }
      // }
    },
    // 设置平台信息
    setPlatform(state) {
      try {
        const userAgent = navigator.userAgent;
        const isWechat = /MicroMessenger/i.test(userAgent);
        if (isWechat) {
          state.platform = 'WX';
          state.isWechat = true;
        } else {
          const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1;
          const isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
          if (isIOS) {
            state.platform = 'IPH';
          } else if (isAndroid) {
            state.platform = 'ADR';
            state.isAndroid = true;
          } else {
            state.platform = 'PC';
          }
        }
      } catch (error) {
        state.platform = '';
        state.isWechat = false;
        state.isAndroid = false;
      }
    },
  },
  actions: {
    // 初始化
    init({ commit }) {
      // 获取平台信息
      commit('setPlatform');
    },
    async initMenu({ commit }) {
      try {
        const data = await serviceApi.getMenuAndButton({});
        console.log(data, 'data');
        const menuList = _.cloneDeep(data.menuList);
        const pathRouter = getRouters(menuList, menuList);
        // router.addRoutes(pathRouter);
        // console.log(router.options.routes, '1');
        // router.options.routes = router.options.routes.concat(pathRouter);
        // console.log(router.options.routes, '2');
        commit('setMenuAndButton', { menuList: data.menuList, permissions: data.permissions });
        return pathRouter;
      } catch (error) {
        // 抛出异常
        // throw error;
        Message({
          message: error,
          type: 'error',
          duration: 3000,
        });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/base.js